import create from "zustand";

import { errorAwareApiFetch } from "../../../../../../apiBindings";
import { storageLocal as storage } from "../../../../../../utils/StorageHandler";
import createFormErrorSlices from "../../../../../../utils/store/formErrors";
import iCheckoutData from "../../../interfaces/iCheckoutData";
import iNotify from "../../../interfaces/iNotify";

interface iHeatingOilAmount {
    amount: number;
    setAmount: (amount: number) => void;
    setAmountStorageToState: () => void;
    storeAmountToStorage: () => void;
    storeAmountToServer: (
        checkoutData: iCheckoutData,
        notify: iNotify,
        onSuccess: () => void | undefined
    ) => Promise<iCheckoutData>;
}

const useStore = create<iHeatingOilAmount>((set, get) => ({
    ...createFormErrorSlices(set, get),
    amount: storage.getInt("hel:amount"),

    setAmount: (amount) => {
        set({ amount: amount });
    },

    setAmountStorageToState: () => {
        set({ amount: storage.get("hel:amount") });
    },

    storeAmountToStorage: () => {
        storage.set("hel:amount", get().amount);
    },

    storeAmountToServer: async (
        checkoutData,
        notify,
        onSuccess
    ): Promise<iCheckoutData> => {
        let checkoutDataResponse = { ...checkoutData };
        const data = {
            hash: checkoutData.user_hash,
            amount: get().amount,
            additionalAddresses: checkoutData.additional_addresses,
        };

        await errorAwareApiFetch<{ data: any }>(`/heatingoil/checkout/amount`, {
            method: "POST",
            body: JSON.stringify(data),
        })
            .then(({ data }) => {
                checkoutDataResponse = data;
                if (onSuccess) {
                    onSuccess();
                }
            })
            .catch(({ data }) => {
                notify("Fehlgeschlagen", data.message);
            });
        return checkoutDataResponse;
    },
}));

export default useStore;
